import { Alert, Typography } from 'src/shared';
import { IconAlert } from 'src/Assets/svg';
import { trb } from '../../Utilities';

export const BlockedOutgoingPaymentsNotification = () => {
  return (
    <Alert
      className="mb-3"
      type="error"
      description={<Typography.Paragraph className="mb-0 error_message">{trb('BlockedOutgoingPayments.Message')}</Typography.Paragraph>}
      showIcon={true}
      icon={
        <div className="align-self-start mr-0 pr-3">
          <IconAlert size={24} />
        </div>
      }
    />
  );
};
